<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px 0 0;overflow-y: auto" v-loading="loading" element-loading-text="加载中，请耐心等待。">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto;padding-left: 20px;box-sizing: border-box">
          <tree-data ref="tree" @checkChange="checkChange"></tree-data>
        </el-col>
        <el-col :span="20" style="height: 100%;padding-left: 20px;box-sizing: border-box">
          <div style="height: 50px">
            <el-button type="primary" plain icon="el-icon-plus" @click="addSIP()">新建</el-button>&nbsp;
            <el-input
              prefix-icon="el-icon-search"
              placeholder="输入SIP用户名/SIP话机侧用户名搜索"
              v-model="searchKeyword"
              clearable
              style="width: 300px"
            >
            </el-input>
          </div>
          <div style="max-height: calc(100% - 100px);overflow-y: auto">
            <el-table
              :data="tbdata"
              border
              style="width: 100%"
              highlight-current-row
              ref="singleTable">
              <el-table-column
                type="index"
                label="序号"
                width="50"
              align="center">
              </el-table-column>
              <el-table-column  label='SIP用户名' min-width="80" align="center">
                <template slot-scope="scope">
                  {{scope.row.username}}
                </template>
              </el-table-column>
              <el-table-column  label='SIP密码' min-width="80" align="center">
                <template slot-scope="scope">
                  {{scope.row.password}}
                </template>
              </el-table-column>
              <el-table-column  label='SIP话机侧用户名' min-width="110" align="center">
                <template slot-scope="scope">
                  {{scope.row.sip_username}}
                </template>
              </el-table-column>
              <el-table-column  label='SIP话机侧密码' min-width="100" align="center">
                <template slot-scope="scope">
                  {{scope.row.sip_password}}
                </template>
              </el-table-column>
              <el-table-column  label='SIP组织' min-width="70" align="center">
                <template slot-scope="scope">
                  {{scope.row.sip_orgid}}
                </template>
              </el-table-column>
              <el-table-column  label='SIP坐席组' min-width="80" align="center">
                <template slot-scope="scope">
                  {{scope.row.sip_id_list}}
                </template>
              </el-table-column>
              <el-table-column  label="SIP服务器地址" min-width="120" align="center">
                <template slot-scope="scope">
                  {{scope.row.sip_svrip}}
                </template>
              </el-table-column>
              <el-table-column  label="绑定客服" min-width="130" align="center">
                <template slot-scope="scope">
                  {{isBindUser(scope.row.syspersonid)}}
                </template>
              </el-table-column>
              <el-table-column  label="所属组织" min-width="140" align="center">
                <template slot-scope="scope">
                  {{isOrgName(scope.row.orgid)}}
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="80">
                <template slot-scope="scope">
                  <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editSIP(scope.row)"></i>
                  <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delSIP(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top: 10px;height: 40px;text-align: center">
            <el-pagination v-fixZoom
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCells">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--添加/修改-->
    <el-dialog
      :visible.sync="addEditShow"
      v-if="addEditShow"
      width="800px"
      :show-close="true"
      :close-on-click-modal="false"
      center
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>{{sipTitle}}</span>
        </div>
        <div class="line-title"></div>
      </div>
      <sip-add-edit :sipAddEditRow="addEditRow" v-model="addEditShow"></sip-add-edit>
    </el-dialog>
  </div>
</template>

<script>
import treeData from '../treeData/treeData.vue'
import sipAddEdit from './childComponents/sipAddEdit'
import {querysip, deletesip} from '../../api/sipPhone'
export default {
  name: 'SIPphone',
  components: {treeData, sipAddEdit},
  data () {
    return {
      filterText: '',
      orgData: [],
      expandedKeys: [],
      isFirst: [],
      searchKeyword: '',
      loading: false,
      tableData: [],
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      sipTitle: '',
      addEditShow: false,
      addEditRow: {
        isAdd: true,
        orgTree: [],
        row: {}
      }
    }
  },
  created () {
    this.golobleObject.updateTableSIP = this.sipPhoneData
  },
  mounted () {
  },
  computed: {
    tbdata () {
      return this.searchFilterWord()
    }
  },
  methods: {
    checkChange (obj) {
      if (obj.type === 'check') {
        this.currentPage = 1
        this.isFirst = obj.orgids
        this.getEndTable()
      } else if (obj.type === 'data') {
        this.orgData = obj.orgData
        this.addEditRow.orgTree = obj.treeData
        this.sipPhoneData()
      }
    },
    sipPhoneData () {
      querysip().then(res => {
        let isTime = res.data.orgsips.length / this.pageSize
        if (isTime !== parseInt(isTime)) {
          isTime = parseInt(isTime) + 1
        }
        if (isTime < this.currentPage) {
          if (this.currentPage !== 1) {
            this.currentPage -= 1
          }
        }
        this.tableData = res.data.orgsips
        this.getEndTable()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    getEndTable () {
      this.showTable = []
      if (this.isFirst.length === 0) {
        this.showTable = this.tableData
      } else {
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.isFirst.indexOf(this.tableData[i].orgid) > -1) {
            this.showTable.push(this.tableData[i])
          }
        }
      }
    },
    // table数据入口（tbdata）
    searchFilterWord () {
      const data = this.showTable
      // console.log(this.showTable)
      const vm = this
      const search = data.filter((val) => {
        if (val.username.includes(vm.searchKeyword) || val.sip_username.includes(vm.searchKeyword)) {
          return true
        }
      })
      vm.totalCells = search.length
      const arr = []
      for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
        if (!search[i]) {
          break
        }
        arr.push(search[i])
      }
      return arr
    },
    // 表格
    isBindUser (id) {
      if (id === 0) {
        return '未绑定'
      }
    },
    isOrgName (id) {
      for (let i = 0; i < this.orgData.length; i++) {
        if (id === this.orgData[i].id) {
          return this.orgData[i].name
        }
      }
    },
    // 新建SIP电话
    addSIP () {
      this.sipTitle = '新建SIP电话'
      this.addEditRow.isAdd = true
      this.addEditShow = true
    },
    // 编辑SIP电话
    editSIP (row) {
      this.addEditRow.isAdd = false
      this.addEditRow.row = row
      this.sipTitle = '更新SIP电话'
      this.addEditShow = true
    },
    // 删除SIP电话
    delSIP (row) {
      let name = row.username
      this.$confirm('此操作将永久删除该SIP电话【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          sipids: [row.id]
        }
        deletesip(data).then(res => {
          this.sipPhoneData()
          this.$notify({
            title: '成功',
            message: '删除SIP电话成功',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {
          this.$notify.error({
            title: '失败',
            message: '删除SIP电话失败'
          })
        })
      }).catch(() => {})
    },
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/SIPphone.vue